export default {
  searchTerm: state => state.searchTerm,
  pageSize: state => state.pageSize,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  status: state => state.status,
  filterBy: state => state.filterBy,
  activeTab: state => state.activeTab,
  tabs: state => state.tabs,
  source: state => state.source,
  device: state => state.device,
  devices: state => state.devices,
  totalDevices: state => state.totalDevices,
  deviceTypes: state => state.deviceTypes,
  deviceFiles: state => state.deviceFiles,
  deviceFile: state => state.deviceFile,
  totalDeviceFiles: state => state.totalDeviceFiles,
  currentDevice: state => state.currentDevice,
  tools: state => state.tools,
  totalTools: state => state.totalTools,
  toolMakes: state => state.toolMakes,
  totalFoundDevices: state => state.totalFoundDevices,
  foundDevices: state => state.foundDevices,
  assignedDevices: state => state.assignedDevices,
  totalAssignedDevices: state => state.totalAssignedDevices
}



// WEBPACK FOOTER //
// ./src/store/modules/devices/getters.js